import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '../environment';
import { AuthState, User } from '../interfaces';

export const AuthAPI = createApi({
  reducerPath: 'authAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: env.apiUrl + '/auth',
  }),
  endpoints: (build) => ({
    login: build.mutation<AuthState, Pick<User, 'email' | 'password'>>({
      query: (body) => ({
        url: '/login',
        method: 'POST',
        body,
      }),
    }),
    register: build.mutation<AuthState, Partial<User>>({
      query: (body) => ({
        url: '/register',
        method: 'POST',
        body,
      }),
    }),
    verifyEmail: build.mutation<unknown, Pick<User, 'email'>>({
      query: (body) => ({
        url: '/verify/email',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: build.mutation<void, { password: string; token: string }>({
      query: ({ password, token }) => ({
        url: '/reset/password?token=' + token,
        method: 'POST',
        body: { password },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyEmailMutation,
  useResetPasswordMutation,
} = AuthAPI;